import { isScreen } from '@amzn/showtime';
// RNW native component screens are required to have an rnwPath
export function isRnwScreen(p) {
    return isScreen(p) && (p.rnwPath !== undefined);
}
function mergePathConfigMaps(pathConfigMaps) {
    return pathConfigMaps.reduce((previousValue, currentValue) => (Object.assign(Object.assign({}, previousValue), currentValue)), {});
}
export default function LinkingConfig(placements) {
    const screenConfigMaps = placements.filter(isRnwScreen).map((s) => ({
        [s.id]: s.rnwPath,
    }));
    const screens = mergePathConfigMaps(screenConfigMaps);
    return {
        // prefixes is required but only supported on iOS and Android
        prefixes: [],
        config: { screens },
    };
}
//# sourceMappingURL=LinkingConfig.js.map